import { render } from "./FloatContent.vue?vue&type=template&id=71f4152c"
import script from "./FloatContent.vue?vue&type=script&lang=js"
export * from "./FloatContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__